var map = {
	"./de.json": 7491,
	"./en.json": 8217,
	"./es.json": 2990,
	"./fr.json": 1964,
	"./ja.json": 7602,
	"./ko.json": 716,
	"./ru.json": 9631,
	"./th.json": 6267,
	"./zh-hans.json": 9189,
	"./zh-hant.json": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;